var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"toast"},_vm._l((_vm.messages),function(message,index){return _c('p',{key:index},[_vm._v(_vm._s(message))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }